import {
  AutoComplete as BaseAutoComplete,
  AutoCompleteProps as BaseAutoCompleteProps,
} from 'antd'

export interface AutoCompleteProps extends BaseAutoCompleteProps {}

export const AutoComplete = (props: AutoCompleteProps): JSX.Element => (
  <>
    <BaseAutoComplete {...props} />
  </>
)
